export default __webpack_public_path__ + "static/media/mobile-homeindicator.2c41f9a2.svg";